import { Params } from 'embed/services/QueryParams'
import { ActionTypes } from 'embed/actions'
// NO-OP since params are read-only

export const initialParamsState = {}
// @TODO: is this whole file dead code? if so lets delete it
export default (state: Params = initialParamsState, action: ActionTypes) => state
